<template>
<Fragment>
    <LoadingApp
        :isLoading.sync="isLoading" 
        :is_full_page="true"
    /> 
    <div v-if="client && !hasComment" class="add-product-review">
        <c-heading-2 class="text-uppercase heading-text-color font-weight-semibold" id="review-link" >Deixe sua avaliação</c-heading-2>
        <div class="collateral-box">
            <ul>
                <li>
                    <star-rating 
                        v-model="form.points"
                        :star-size="25"
                    >
                    </star-rating>
                </li>
            </ul>
        </div>
        <form 
            @submit.prevent="submit" 
        >   
            <c-form-group class="form-group mb-2">
                <label for="title-rating">Título<span class="required">*</span></label>
                <input 
                    v-model="form.title"
                    class="form-control form-control-sm"
                    id="title-rating"
                    name="title-rating"
                    required
                />
            </c-form-group><!-- End .form-group -->
            <c-form-group class="form-group mb-2">
                <label for="comment-rating">Seu comentário<span class="required">*</span></label>
                <textarea 
                    v-model="form.comment"
                    cols="3" 
                    rows="4" 
                    class="form-control form-control-sm"
                    required
                    id="comment-rating"
                    name="comment-rating"
                    style="max-width: 100%;"
                ></textarea>
            </c-form-group><!-- End .form-group -->

            <c-button 
                :backgroundColor="$root.$children[0].theme.products.button.background_color"
                :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="$root.$children[0].theme.products.button.color_hover"
                :borderColor="$root.$children[0].theme.products.button.border_color"
                :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                margin="0px 0rem 0px 5px"
                textTransform="uppercase"
                height="3.8rem"
                minWidth="unset"
                padding="1rem 2rem"
                display="flex"
                textAlign="center"
                lineHeight="1.5"
                letterSpacing="unset"
                transition="all .3s"
                justifyContent="center"
                :borderRadius="$root.$children[0].theme.products.button.border_radius"
                :disabled="disabledButton"
                type="submit"
                aria-label="Adicionar avaliação"
            >
                <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Enviar</span>
            </c-button>
        </form>
    </div>
    <ListReviews  :item="item" />
</Fragment>
</template>

<script>
import { CButton } from '../Styles/Button/styled'
import StarRating from 'vue-star-rating'
import {Fragment} from 'vue-fragment'
import {mapState, mapActions} from 'vuex'
import ListReviews from './ListReviews.vue'
import LoadingApp from '../LoadingApp.vue'
import { CFormGroup, CHeading2 } from '../Styles/Components/styled'

export default {
    name:'ReviewForm',
    components: {
        'c-button': CButton,
        StarRating,
        Fragment,
        ListReviews,
        LoadingApp,
        'c-form-group': CFormGroup,
        'c-heading-2': CHeading2
    },
    props: {
        item: {
            required: true,
            type: Object,
        }
    },
    data() {
        return { 
            form: {
                title: null,
                comment: null,
                points: 1,
                product_id: this.item.id,
                user_id: null
            },
            disabledButton: false,
            isLoading: false
        }
    },
    methods: {
        ...mapActions("rate", [
            "ActionCreateRating"
        ]),
        async submit() {
            try {
                this.isLoading = true
                this.disabledButton = true
                await this.ActionCreateRating(this.form)
                location.reload()
            } catch(error) {
                this.isLoading = false
                this.disabledButton = false
                if(error.validator) {
                    let errors = ''
                    for (var [key, value] of Object.entries(error.validator)) {
                        errors += '* '+value+'\n'
                    }
                    return alert(errors)
                }
                alert(error?.msg ?? error)
            }
        },
    },
    watch: {
        client(client) {
            if(!client) {
                return
            }
            this.form.user_id = client.id
        }
    },
    computed: {
        ...mapState("clients", [
            "client"
        ]),
        hasComment() {
            return this.item?.has_comment === false ? false : true
        
        }
    }
}
</script>

<style>

</style>